import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';

/** @type {GameBackground} */
let gameBackground = null;
const MAX_CLOUDS = 10;
const DELAY_BETWEEN_CLOUDS = 2000; // in milliseconds

export function getGameBackground()
{
    return gameBackground;
}

export default class GameBackground extends Phaser.Scene
{
    static get KEY() { return 'GameBackground'; }

    constructor()
    {
        super({ key: (GameBackground).KEY });

        gameBackground = this;
    }

    create()
    {
        this.clouds = [];
        this.curWidth = this.scale.width;
        this.curHeight = this.scale.height;
        //camera move directions 0 = up, 1 = right, 2 = down, 3 = left, -1 = none
        this.panDirection = -1;

        this.setUpGame();

        this.timeUntilNextCloud = DELAY_BETWEEN_CLOUDS;

        this.scene.launch(gameData.firstScene);

        //ABCyaPhaser.Debug.addScreenReference(this, "ref", "assets/1 Title-01.png")
    }

    setUpGame()
    {
        //blue sky
        this.bgLayer = this.add.rectangle(0, 0, this.scale.width, this.scale.height, 0x6dc9c5).setOrigin(0);

        //grass
        this.grassLayer = this.add.container();
        this.mountains = ABCyaPhaser.Images.addImage(-31, 2, UIAssetKeys._game_items_bckg_horizon, this.grassLayer).setOrigin(0, 1);
        if (gameData.isMobile) this.mountains.setScale(0.75);
        let grass1 = ABCyaPhaser.Images.addImage(0, -24, gameData.isMobile ? UIAssetKeys._mobile_grass_mobile_withblanket : UIAssetKeys._grass_portrait_withblanket, this).setOrigin(0);
        let grass2 = ABCyaPhaser.Images.addImage(0, -24, gameData.isMobile ? UIAssetKeys._mobile_grass_mobile : UIAssetKeys._grass_portrait, this).setOrigin(0);
        let grass3 = ABCyaPhaser.Images.addImage(0, -24, gameData.isMobile ? UIAssetKeys._mobile_grass_mobile : UIAssetKeys._grass_portrait, this).setOrigin(0);
        this.grassLayer.add([grass1, grass2, grass3]);
        this.resetToBlanket();

        this.horizonMin = this.scale.height - grass1.height + 24;

        this.horizon = this.horizonMin;

        /** @type {Phaser.GameObjects.Image[]} */
        this.clouds = [];
        while (this.clouds.length < MAX_CLOUDS)
        {
            this.addNewCloud(true);
        }

        this.bgReady = true;
    }

    pan(dir, speed)
    {
        if (speed == null) speed = 5;
        switch (dir)
        {
            case "up":
                this.panDirection = 0;
                break;
            case "right":
                this.panDirection = 1;
                break;
            case "down":
                this.panDirection = 2;
                break;
            case "left":
                this.panDirection = 3;
                break;
            case "stop":
                this.panDirection = -1;
                break;
        }

        //set pandata here
        let panData = this.getPanAmount(speed);

        this.moveAmt = panData.moveAmt;
        this.moveType = panData.moveVal;
    }

    update(time, delta)
    {
        //panning on tick
        if (!this.bgReady) return;
        if (this.panDirection != -1)
        {
            if (this.moveType == "x")
            {
                //move grass pieces to simulate move left
                this.panXAmount = (this.moveAmt * 60 * delta / 1000);
                //move all grass pieces
                for (let g = 1; g < 4; g++)
                {
                    let grassPiece = this.grassLayer.getAt(g);
                    grassPiece.x += this.panXAmount;
                }
            }
            else
            {
                this.panXAmount = 0;
                let newHorizon = this.horizon + (this.moveAmt * 60 * delta / 1000);
                if (newHorizon < this.horizonMin)
                {
                    newHorizon = this.horizonMin;
                    this.panDirection = -1;
                }
                else if (newHorizon > this.scale.height)
                {
                    newHorizon = this.scale.height;
                    this.panDirection = -1;
                }

                this.horizon = newHorizon;
            }
        }
        else
        {
            this.panXAmount = 0;
        }

        if (this.grassLayer) this.grassLayer.y = this.horizon;

        if (this.clouds.length > 0)
        {
            for (let i = 0; i < this.clouds.length; i++)
            {
                let cloud = this.clouds[i];
                cloud.x += cloud._velX;
                cloud.y = this.horizon - cloud._cloudHeight;
                if (cloud.x > this.curWidth || cloud.y <= -cloud.displayHeight)
                {
                    cloud.destroy();
                    this.clouds.splice(i, 1);
                    i--;
                }
            }
        }

        if (this.clouds.length < MAX_CLOUDS && this.timeUntilNextCloud <= 0)
        {
            this.timeUntilNextCloud = DELAY_BETWEEN_CLOUDS;
            this.addNewCloud(false);
        }
        else
        {
            this.timeUntilNextCloud -= delta;
        }
    }

    addNewCloud(startFlag)
    {
        let cloudNum = Phaser.Math.Between(1, 5);
        let cloud = ABCyaPhaser.Images.addImage(0, 0, 'game-items/cloud-' + cloudNum + '_0', this).setOrigin(0);
        let horizonSpace = 200;
        cloud.scale = Phaser.Math.Between(80, 100) / 100;
        cloud._velX = 0.6;
        //place clouds across screen when starting up
        let tries = 0;
        do
        {
            tries++;
            cloud.x = (startFlag == true) ? Phaser.Math.Between(0, this.scale.width) : -cloud.displayWidth;

            let cloudY = Phaser.Math.Between(0, this.horizon - horizonSpace);
            cloud._cloudHeight = this.horizon - cloudY;
            cloud.y = this.horizon - cloud._cloudHeight;
        }
        while (this.clouds.some(c => Phaser.Geom.Rectangle.Overlaps(cloud.getBounds(), c.getBounds())) && tries < 10);

        this.children.moveTo(cloud, 1);
        this.clouds.push(cloud);
    }

    resetToBlanket()
    {
        let xPos = gameData.isMobile ? -128 : 0;
        for (let g = 1; g < 4; g++)
        {
            let grassPiece = this.grassLayer.getAt(g);
            grassPiece.x = xPos;
            xPos += grassPiece.width;
        }
    }

    setHorizon(highOrLow)
    {
        this.horizon = (highOrLow == "high") ? this.horizonMin : this.scale.height;
    }

    /**
     * 
     * @param {number} speed 
     * @returns 
     */
    getPanAmount(speed)
    {
        let dir;
        let amt;
        switch (this.panDirection)
        {
            case 0:
                dir = "y";
                amt = speed;
                break;
            case 1:
                dir = "x";
                amt = -speed;
                break;
            case 2:
                dir = "y";
                amt = -speed;
                break;
            case 3:
                dir = "x";
                amt = speed;
                break;
        }

        return { moveVal: dir, moveAmt: amt };
    }
}